import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import { ERROR_MSG } from "../../../constants/common";
import {
    RESET_LOADER,
    SET_ERROR,
    SET_LOADER,
} from "../../../constants/contexConstant";
import { useContextState } from "../../../context/ContextProvider";
import request from "../../../services/request";
import Container from "../../../shared/Container";
import Section from "../../../shared/Section";
import Button from "../../../shared/ui/Button";
import CloseButton from "../../../shared/ui/CloseButton";
import DrawerAndModalWrapper from "../../../shared/ui/Drawer/DrawerAndModalWrapper";
import FormikLabeledInput from "../../../shared/ui/Form/FormikLabeledInput";
import LabeledFormikSelect from "../../../shared/ui/Form/LabeledFormikSelect";
import Info from "../../../shared/ui/Info";
import BorderedTab from "../../../shared/ui/tab/BorderedTab";
import LinedTab from "../../../shared/ui/tab/LinedTab";
import PaymentCard from "../../timeline/book-now/PaymentCard";
import PaymentHistory from "../../timeline/book-now/PaymentHistory";

const ADMIN_PAYMENT_APPROVAL = "/admin/payment/approval";

const initValues = {
    status: "",
    received: "",
};
const AdminPaymentReceipt = ({ onClick, receipts, history, setHistory }) => {
    const [currentTab, setCurrentTab] = useState(0);
    const [initialValues, setInitialValues] = useState(initValues);
    const { dispatch } = useContextState();
    const [approvalData, setApprovalData] = useState(null);

    const handleTabClick = (val) => {
        setCurrentTab(val);
    };

    const handleClosePopup = () => {
        setApprovalData(null);
        setInitialValues(initValues);
    };

    const handleUpdate = (val) => {
        setApprovalData(val);
        setInitialValues({ ...initialValues, received: val.amount });
    };
    const handleSubmit = async (values, actions) => {
        try {
            dispatch({ type: SET_LOADER });
            await request.authPut({
                endpoint: ADMIN_PAYMENT_APPROVAL,
                body: {
                    type: "CustomerPayment",
                    id: approvalData?.paymentId,
                    amount: values?.received,
                    status: values?.status,
                },
            });

            dispatch({ type: RESET_LOADER });
            let newArray = history.map((item) => {
                if (item?.paymentId === approvalData?.paymentId) {
                    return { ...item, paymentStatus: values?.status };
                }
                return item;
            });

            setHistory(newArray);

            setApprovalData(null);
            setInitialValues(initValues);
        } catch (error) {
            dispatch({ type: RESET_LOADER });
            dispatch({
                type: SET_ERROR,
                payload: typeof error === "string" ? error : ERROR_MSG,
            });
        }
    };
    return (
        <Section className=" bg-white pb-6 mb-0">
            <div className="min-h-[128px] bg-blue-700 lg:hidden"></div>
            <div className="pt-2 rounded-3 bg-white -mt-3 lg:mt-0 lg:pt-0">
                <Container>
                    <CloseButton onClick={onClick} className="lg:hidden" />
                    <LinedTab
                        className="pb-0  mt-0 pt-0 w-full border-b border-blue-200 mb-2 lg:hidden"
                        activeClass={
                            "text-blue font-medium duration-300 w-[130px]"
                        }
                        inActiveClass={"text-gray-370 w-[130px] "}
                        data={["Receipt", "Payment History"]}
                        activeTab={currentTab}
                        onClick={handleTabClick}
                    />

                    <BorderedTab
                        currentTab={currentTab}
                        onTabClick={(tab) => setCurrentTab(tab)}
                        options={["Receipt", "Payment History"]}
                        className="bg-transparent gap-0 my-2.4 xl:my-1.5 border rounded-sm font-vietnam lg:font-vietnam hidden lg:flex "
                        activeClass={`w-1/2 rounded-none bg-gray-100 text-primary rounded-none text-sm  ${
                            currentTab === 0
                                ? "rounded-r-none"
                                : "rounded-l-none"
                        } `}
                        inActiveClass="w-1/2 rounded-none bg-transparent text-primary text-sm"
                    />

                    {currentTab === 0 ? (
                        receipts?.length === 0 ? (
                            <Info message="No receipts available" />
                        ) : (
                            receipts.map((item, index) => {
                                return (
                                    <div key={index} className="mb-2">
                                        <PaymentCard
                                            heading={item?.name}
                                            status={item?.status}
                                            statusType={
                                                item?.status === "PAID"
                                                    ? "success"
                                                    : "warn"
                                            }
                                            due={item?.amountDue}
                                            paid={item?.amountPaid}
                                            showCircle={false}
                                        />
                                    </div>
                                );
                            })
                        )
                    ) : (
                        <PaymentHistory
                            onUpdate={handleUpdate}
                            data={history}
                        />
                    )}
                </Container>
            </div>

            <DrawerAndModalWrapper
                isOpen={approvalData}
                onClose={handleClosePopup}
                modalContentClass="bg-white"
            >
                <Formik
                    initialValues={initialValues}
                    validationSchema={yup.object().shape({
                        status: yup.string().required().label("Status"),
                        received: yup
                            .number()
                            .required()
                            .label("Received amount"),
                    })}
                    onSubmit={handleSubmit}
                >
                    {({}) => (
                        <Form>
                            <div className="  py-2 pb-5  flex flex-col gap-y-2 ">
                                <FormikLabeledInput
                                    name="received"
                                    label="Payment Received"
                                />
                                <LabeledFormikSelect
                                    name="status"
                                    label="Payment Status"
                                    options={PAYMENT_STATUS}
                                />

                                <Button type="submit" className="bg-primary">
                                    Update Payment
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </DrawerAndModalWrapper>
        </Section>
    );
};

export default AdminPaymentReceipt;
const PAYMENT_STATUS = [
    {
        label: "PAID",
        value: "PAID",
    },
    {
        label: "PENDING",
        value: "PENDING",
    },
    {
        label: "CANCELLED",
        value: "CANCELLED",
    },
];
